.toggle-icon{scale:1;padding:0;transform:translateY(12px);display:inline-block;width:6px;height:6px}
/*# sourceMappingURL=toggle-view-modes-button.component.css.map */
